<template>
  <div class="wxPayment w1200">
    <h4>订单提交成功，请尽快付款</h4>
    <h6>订单编号：{{ payId }}</h6>
    <h5>
      扫一扫付款：<span>¥ {{ orderAmount }}</span>
    </h5>
    <div class="payType">
      <img src="@/assets/images/WECHATPAY.png" alt="" class="pay-method-img" />
      <img :src="payCode" alt="" class="qrcode" />
      <div class="scan">
        <span class="iconfont icon-saoma vb"></span>
        <span class="tip">
          打开手机微信<br />
          扫一扫继续支付
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WXPayment',
  data() {
    return {
      payId: '',
      payCode: '',
      orderAmount: 0,
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.wxPayment {
  background-color: #fff;
  padding: 40px 0;
  h4 {
    font-weight: 600;
    color: #262626;
    font-size: 24px;
    margin-bottom: 24px;
    text-align: center;
  }
  h6 {
    font-size: 16px;
    font-weight: 400;
    color: #595959;
    line-height: 24px;
    margin-bottom: 4px;
    text-align: center;
  }
  h5 {
    font-size: 16px;
    font-weight: 400;
    color: #595959;
    line-height: 32px;
    display: flex;
    justify-content: center;
    margin: 0;
    span {
      color: #f56c6c;
      font-weight: 600;
      font-size: 24px;
    }
  }
  .payType {
    position: relative;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    width: 208px;
    height: auto;
    margin: 24px auto 0px;
    padding: 24px 0px;
    .pay-method-img {
      height: 24px;
      margin: 0px auto;
      display: block;
    }
    .qrcode {
      width: 185px;
      height: 185px;
      display: block;
      margin: 16px auto;
    }
    .scan {
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      .vb {
        margin-right: 15px;
        display: block;
        font-size: 40px;
        color: #2b82ff;
      }
      .tip {
        font-size: 14px;
        line-height: 22px;
        color: #595959;
      }
    }
  }
}
</style>
